"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = require("../index");
const Secondary_1 = __importDefault(require("../../Secondary"));
/**
 * _Secondary Call to Action Button_
 *
 * The secondary CTA button compliments the primary CTA button and is placed below the CTA primary button.
 * The secondary CTA button should not take the form of full sentences.
 *
 * **Scaling for responsive screen size:**
 * Rounded buttons are 100% width for xsmall-small breakpoints.
 * When pairing with a rounded CTA button, the two buttons can only be stacked vertically with a spacing of 16px.
 * */
const SecondaryCTA = (0, styled_components_1.default)(Secondary_1.default) `
  ${index_1.CTABaseStyles};
  border: 1px solid ${({ theme }) => theme.palette.gray[10]};
`;
exports.default = SecondaryCTA;
//# sourceMappingURL=index.js.map